import React from "react";

const GradientButtonMobile = ({ text, onClick, disabled }) => {
  return (
    <button
      className="gradient-button-mobile"
      onClick={onClick}
      disabled={disabled}
    >
      {text}
    </button>
  );
};

export default GradientButtonMobile;
